module.exports = __webpack_public_path__ + "static/media/How to Transfer to simple.4db117a7.png";